/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'upload': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g _fill="none" _stroke="currentColor" stroke-width="2"><path pid="0" d="M1 9v6h14V9M8 11V2M3 6l5-5 5 5"/></g>'
  }
})
